import React, { useState } from "react";

import DetailsList from "./DetailsList";
import Rating from "../../../components/Rating";
import Section from "../../../components/Section";
import Background from "../../../components/Background";
import ShareDialog from "../../../components/DialogBox/ShareDialog";

import style from "./style.module.css";

export default function BookDetail(props) {
    const { 
        id, 
        image, 
        rating = 0,
    } = props;

    const [popup, setPopup] = useState(false);

    return (
        <>
            <Section className={style.bookPage}>
                <div className={style.colRow}>
                    <div className={style.col1}>
                        <div className={style.colInner}>
                            <div className={style.singleImageWrap}>
                                <Background src={image} size={`${image?.width ?? 260}x${image?.height ?? 400}`} />
                            </div>
                        </div>
                    </div>
                    <div className={style.col2}>
                        <div className={style.colInner}>
                            <DetailsList  {...props} />
                            <div className={style.fourContentItem}>
                                <div className={style.bookRate}>
                                    <Rating type="book" id={id} rating={rating} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Section>
            {
                popup === "share" && (
                    <ShareDialog onClose={() => setPopup(false)} />
                )
            }
        </>
    )
}
